import React from "react";
type Props = {
  value: number;
};

export const SpacingHeight: React.FC<Props> = ({ value }) => {
  return <div style={{ height: `${value}px` }}></div>;
};
